import styled from '@emotion/styled'
import { isMobile } from '@const/device'

const DesktopWrapper = styled.div<{ minHeightVh: number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  min-height: ${({ minHeightVh }) => `${minHeightVh}vh`};
  min-width: 800px;

  &.manual-final-test-modal {
    min-height: calc(95vh - 94px);
    box-sizing: border-box;

    h1,
    h2 {
      margin-top: 0;
      margin-bottom: 0;
      font-size: 28px;
      line-height: 34px;
      font-weight: 700;
      letter-spacing: 0;
      white-space: normal;
    }

    #content {
      margin-top: 14px;
    }

    #contentFields > div > div {
      gap: 24px;
    }

    #contentFields label {
      padding-top: 0;
    }

    @media (min-width: 768px) {
      #contentFields label {
        white-space: nowrap;
      }
    }

    #contentFields input {
      font-size: 14px;
      padding: 10px 16px;
    }

    > div:last-child {
      margin-top: 28px;
      gap: 16px;
    }

    > div:last-child button {
      width: auto;
      min-width: 158px;
    }

    @media (max-width: 767px) {
      min-width: 100%;
      min-height: auto;
      overflow: hidden;

      #contentFields {
        overflow: hidden;
      }

      #contentFields > div {
        width: 100%;
      }

      #contentFields > div > div {
        width: 100%;
        flex-direction: column;
        gap: 12px;
      }

      #contentFields > div > div > div,
      #contentFields label {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        white-space: normal;
      }

      #contentFields input {
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
`
const MobileWrapper = styled(DesktopWrapper)<{ minHeightVh: number }>`
  min-height: 10vh;
  min-width: 100%;

  &.manual-final-test-modal {
    min-height: auto;
    overflow: hidden;

    #contentFields {
      overflow: hidden;
    }

    #contentFields > div {
      width: 100%;
    }

    #contentFields > div > div {
      width: 100%;
      flex-direction: column;
      gap: 12px;
    }

    #contentFields > div > div > div,
    #contentFields label {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }

    #contentFields label {
      white-space: normal;
    }

    #contentFields input {
      width: 100%;
      box-sizing: border-box;
    }

    > div:last-child {
      flex-direction: column;
    }

    > div:last-child button {
      width: 100%;
    }
  }
`
export const Wrapper = isMobile ? MobileWrapper : DesktopWrapper
